import { TGetDashboardProductInventoryAPIParams, TGetDashboardProductInventoryAPIResponse, TGetDashboardProductPricingAPIParams, TGetDashboardProductPricingAPIResponse, TGetDashboardSilverProductPricingAPIParams, TGetDashboardSilverProductPricingAPIResponse } from '~types/feat/dashboard';
import Gateway from './gateway';
import { GatewayResponse } from '~types/gateway';

export abstract class IDashboardGateway extends Gateway {
    abstract getDashboardProductPricing(params: TGetDashboardProductPricingAPIParams): GatewayResponse<TGetDashboardProductPricingAPIResponse>;

    abstract getDashboardProductInventory(params: TGetDashboardProductInventoryAPIParams): GatewayResponse<TGetDashboardProductInventoryAPIResponse>;

    abstract getDashboardSilverProductPricing(params: TGetDashboardSilverProductPricingAPIParams): GatewayResponse<TGetDashboardSilverProductPricingAPIResponse>;
}
